import React, { useMemo, useCallback } from 'react';
import { Grid } from '@mui/material';
import GenericDropdown from '@shared/components/GenericDropdown';

const SellerSelectorContent = ({
  seller,
  main_sellers,
  handleSeller,
  error = false,
  helperText = '',
}) => {
  const items = useMemo(
    () =>
      main_sellers?.map(s => ({
        id: s.id_user,
        fragments: [{ text: `${s.name} ${s.last_name}`, bold: false }],
      })) || [],
    [main_sellers]
  );

  const selectedItem = useMemo(() => {
    if (!seller) return null;
    return {
      id: seller.id_user,
      fragments: [{ text: `${seller.name} ${seller.last_name}`, bold: false }],
    };
  }, [seller]);

  const handleSelect = useCallback(
    item => {
      const selected = main_sellers?.find(s => s.id_user === item.id);
      if (!selected) return;

      handleSeller(selected);
    },
    [main_sellers, handleSeller]
  );

  return (
    <Grid item xs={12} md={12}>
      <GenericDropdown
        items={items}
        selectedItem={selectedItem}
        onSelect={handleSelect}
        buttonLabel="Seleccioná tu vendedor"
        heightAuto
        hasError={error}
        helperText={helperText}
      />
    </Grid>
  );
};

export default SellerSelectorContent;
